import React, { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Button, Grid, Icon, Input, Loader } from 'semantic-ui-react'
import './CNCDictBatchChange.css'
import axios, { AxiosInstance } from 'axios'
import { Meta, RatatoskRequest } from '../../common'

interface CNCDictBatchChangeProps extends WithTranslation {
    meta: Meta,
    http: AxiosInstance,
    formik: any,
    group: string,
    form: string|null,
    pos?: string,
    setLemma: (formik, group, form, value) => void,
    setDomain: (formik, group, form, domain, value) => void,
    setActive: (formik, group, form, value) => void,
    setActiveByTag?: (formik, group, tag, value) => void,
    searchReplace?: (formik, group, search, replace) => void,
    close: () => void
}

interface CNCDictBatchChangeState {
    newLemma: string,
    search: string,
    replace: string,
    testingLemma: boolean,
    existingLemma: lemmaPresent
}

export enum lemmaPresent {
    unknown,
    none,
    asLemma,
    asSublemma
}

export const batchByTag = {
    N: {
        'singular': '...S.*',
        'plural': '...P.*'
    },
    V: {
        'affirmative': '..........A.*',
        'negative': '..........N.*'
    },
    A: {
        'positive': '.........1.*',
        'comparative': '.........2.*',
        'superlative': '.........3.*',
        'affirmative': '..........A.*',
        'negative': '..........N.*'
    },
    D: {
        'positive': '.........1.*',
        'comparative': '.........2.*',
        'superlative': '.........3.*',
        'affirmative': '..........A.*',
        'negative': '..........N.*'
    }
}


export const checkLemma = async (http: AxiosInstance, form: string, sublemma: boolean = false) => {
    const attr = sublemma ? 'sublemma' : 'lemma'
    let request: RatatoskRequest = {
        query: {
            type: ':cncdict:form',
            feats: [
                {type: ':form:attr:cnc:w:'+attr, value: form, ci: true}
            ]
        },
        page: { from: 0, size: 1 },
        feats: [':form:attr:cnc:w', ':form:cncdict:domain']
    }
    const url = 'cunits/_view'
    try {
        const response = await http.post(url, request)
        if (response.data.total.value)
            return true
        else
            return false
    } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
            console.log(err.response.data.message||err.response.data)
        } else {
            console.log(err)
        }
        return null
    }
}

class CNCDictBatchChange extends Component<CNCDictBatchChangeProps, CNCDictBatchChangeState> {

    state = {
        newLemma: '',
        search: '',
        replace: '',
        testingLemma: false,
        existingLemma: lemmaPresent.unknown
    }

    async updateLemma(form: string) {
        const { http } = this.props
        this.setState({newLemma: form, testingLemma: true})
        const res = await checkLemma(http, form)
        if (res) {
            this.setState({testingLemma: false, existingLemma: lemmaPresent.asLemma})
        } else if (res===false) {
            const res = await checkLemma(http, form, true)
            if (res) {
                this.setState({testingLemma: false, existingLemma: lemmaPresent.asSublemma})
            } else if (res===false) {
                this.setState({testingLemma: false, existingLemma: lemmaPresent.none})
            } else {
                this.setState({testingLemma: false, existingLemma: lemmaPresent.unknown})
            }
        } else {
            this.setState({testingLemma: false, existingLemma: lemmaPresent.unknown})
        }
    }

    render() {
        const { formik, group, form, pos, setLemma, setDomain, setActive, setActiveByTag, searchReplace, close, t, i18n } = this.props
        const { newLemma, search, replace, testingLemma, existingLemma } = this.state
        const [ lemma, tagmask ] = group.split('_')
        const tagSwitches = pos && batchByTag[pos] ? batchByTag[pos] : {}

        return(
            <>
            <Grid.Row className="">
                <Grid.Column width={8}>
                    <Input value={newLemma} fluid onChange={(e, {value}) => this.updateLemma(value)}/>
                </Grid.Column>
                <Grid.Column width={8}>
                    <Button icon="" type="button" color='blue' disabled={!newLemma}
                        onClick={(e,d) => setLemma(formik, group, form, newLemma)}>{t('Set new lemma')}</Button>
                </Grid.Column>
            </Grid.Row>
            { testingLemma || existingLemma !== lemmaPresent.unknown ? (
                <Grid.Row className='compact'>
                    <Grid.Column width={16}>
                    { testingLemma ? <p className='testing-lemma'><Loader active inline size="mini"/>{t("Searching for lemma...")}</p>
                    : existingLemma === lemmaPresent.none ? <p className='no-lemma'><Icon name="warning sign"/>{t('New lemma')}</p>
                    : existingLemma === lemmaPresent.asLemma ? <p className='existing-lemma'><Icon name="check circle"/>{t('Existing lemma')}</p>
                    : existingLemma === lemmaPresent.asSublemma ? <p className='existing-sublemma'><Icon name="warning sign"/>{t('Existing sublemma')}</p>
                    : null }
                    </Grid.Column>
                </Grid.Row>
            ) : null }
            <Grid.Row className='' verticalAlign='middle'>
                <Grid.Column width={3}>
                <Button icon="undo" type="button" size='mini' color='orange' onClick={() => setActive(formik, group, form, true)}/>
                <Button icon="delete" type="button" size='mini' color='red' onClick={() => setActive(formik, group, form, false)}/>
                </Grid.Column>
                <Grid.Column width={13}>
                {t('reactivate / delete all')}
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Grid className='frame'>
                    <Grid.Row className='condensed' verticalAlign='middle'>
                        <Grid.Column width={3}>
                        <Button icon="check" type="button" size='mini' color='blue' onClick={() => setDomain(formik, group, form, 'written', true)}/>
                        <Button icon="delete" type="button" size='mini' color='red' onClick={() => setDomain(formik, group, form, 'written', false)}/>
                        </Grid.Column>
                        <Grid.Column width={13}>
                        {t('written')}
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row className='condensed' verticalAlign='middle'>
                        <Grid.Column width={3}>
                        <Button icon="check" type="button" size='mini' color='blue' onClick={() => setDomain(formik, group, form, 'spoken', true)}/>
                        <Button icon="delete" type="button" size='mini' color='red' onClick={() => setDomain(formik, group, form, 'spoken', false)}/>
                        </Grid.Column>
                        <Grid.Column width={13}>
                        {t('spoken')}
                        </Grid.Column>
                    </Grid.Row>
                    </Grid>
                </Grid.Column>
            </Grid.Row>
            { setActiveByTag && Object.keys(tagSwitches).length ?
            <>
            <Grid.Row>
                <Grid.Column width={16}>
                    <div className='label'>{t('Form groups')}</div>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Grid className='frame'>
                    {Object.keys(tagSwitches).map(label => (
                        <Grid.Row className='condensed' verticalAlign='middle'>
                            <Grid.Column width={3}>
                                <Button icon="undo" type="button" size='mini' color='orange' onClick={() => setActiveByTag(formik, group, tagSwitches[label], true)}/>
                                <Button icon="delete" type="button" size='mini' color='red' onClick={() => setActiveByTag(formik, group, tagSwitches[label], false)}/>
                            </Grid.Column>
                            <Grid.Column width={13}>
                                {t(label)}
                            </Grid.Column>
                        </Grid.Row>
                    ))}
                    </Grid>
                </Grid.Column>
            </Grid.Row>
            </>
            : null}
            { searchReplace ?
            <>
            <Grid.Row>
                <Grid.Column width={16}>
                    <div className='label'>{t('Clone paradigm')}</div>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row className='condensed'>
                <Grid.Column width={6}>{t('expression')}</Grid.Column>
                <Grid.Column width={6}>{t('replace')}</Grid.Column>
            </Grid.Row>
            <Grid.Row className='condensed'>
                <Grid.Column width={6}>
                    <Input value={search} onChange={(e, {value}) => this.setState({search: value})}/>
                </Grid.Column>
                <Grid.Column width={6}>
                    <Input value={replace} onChange={(e, {value}) => this.setState({replace: value})}/>
                </Grid.Column>
                <Grid.Column width={4}>
                    <Button type="button" color="orange" onClick={() => searchReplace(formik, group, search, replace)}>{t('Replace')}</Button>
                </Grid.Column>
            </Grid.Row>
            </>
            : null}
            <Grid.Row>
                <Grid.Column width={16} textAlign='right'>
                    <Button type="button" color="blue" onClick={() => close()}>{t("Close")}</Button>
                </Grid.Column>
            </Grid.Row>
            </>
        )
    }

}

export default withTranslation()(CNCDictBatchChange)